import React from 'react';
import { useStyletron } from 'baseui';
import { useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import useGetOrganization from './useGetOrganization';
import AppLoadingScreen from '../components/screen/AppLoadingScreen';

const Auth0ProviderWithHistory = ({ children }: any) => {
  const scope = 'profile email'; // 'openid profile email';
  const domain = window.env.APP_AUTH0_DOMAIN as string;
  const clientId = window.env.APP_AUTH0_CLIENT as string;
  const audience = window.env.APP_AUTH0_AUDIENCE;
  const advancedOptions = {
    defaultScope: '',
  };
  const [, theme] = useStyletron();

  const navigate = useNavigate();

  const { data, isLoading } = useGetOrganization();

  let organizationKey = window.location.hostname.split('.')[0];

  if (import.meta.env.MODE === 'development') {
    organizationKey = 'stagesi';
  }

  const organizationId = data?.[organizationKey];

  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (isLoading) {
    return <AppLoadingScreen bgColor={theme.colors.mono100} />;
  }

  return (
    <Auth0Provider
      advancedOptions={advancedOptions}
      scope={scope}
      domain={domain}
      clientId={clientId}
      audience={audience}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      organization={organizationId}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
